// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rgXa","content":"styles_content__3IS9E"};